/**
 * Taiwan (TW) payment methods configuration
 *
 * Payment Method Rules (from PAYMENT_FLOWS.md spec):
 * | 訂閱類型 | 金額條件 | 可用付款方式 |
 * |---------|---------|-------------|
 * | 月繳    | 任意     | 信用卡 (唯一) |
 * | 年繳    | < NT$200,000 | 信用卡 (唯一) |
 * | 年繳    | >= NT$200,000 | ATM 匯款 (唯一) |
 */

// Threshold for ATM-only payment (annual subscriptions)
const ATM_THRESHOLD = 200000;

export default {
  // Available payment methods for Taiwan
  availableMethods: ['credit_card', 'bank_transfer'],

  // UI configuration - defaults (used when no subscription context)
  ui: {
    showBankTransfer: false, // Default: don't show bank transfer
    creditCardPrimary: true, // Default: credit card is primary
  },

  // Payment method specific settings
  settings: {
    creditCard: {
      provider: 'payuni',
    },
    bankTransfer: {
      paymentTermsDays: 7,
      // Bank info is fetched from API, not hardcoded here
    },
  },

  /**
   * Get UI config based on subscription context
   *
   * @param {string} billingCycle - 'monthly' or 'annual'
   * @param {number} amount - Subscription amount in TWD
   * @returns {Object} UI configuration
   */
  getUIForSubscription: (billingCycle, amount) => {
    // 月繳: 只能信用卡
    if (billingCycle === 'monthly') {
      return {
        showBankTransfer: false,
        creditCardPrimary: true,
        onlyCreditCard: true,
        onlyBankTransfer: false,
      };
    }

    // 年繳 < NT$200,000: 只能信用卡
    if (billingCycle === 'annual' && amount < ATM_THRESHOLD) {
      return {
        showBankTransfer: false,
        creditCardPrimary: true,
        onlyCreditCard: true,
        onlyBankTransfer: false,
      };
    }

    // 年繳 >= NT$200,000: 只能 ATM 匯款
    if (billingCycle === 'annual' && amount >= ATM_THRESHOLD) {
      return {
        showBankTransfer: true,
        creditCardPrimary: false,
        onlyCreditCard: false,
        onlyBankTransfer: true,
      };
    }

    // Default fallback
    return {
      showBankTransfer: false,
      creditCardPrimary: true,
      onlyCreditCard: true,
      onlyBankTransfer: false,
    };
  },
};
